import React from 'react';
import { useTheme } from 'styled-components';
import { Popover as AntPopover, PopoverProps as AntPopoverProps } from 'antd';
import { CloseIcon } from './styles';

export { CoachMark } from './coachMark';

const typeToClassName = {
  default: 'ui_library_popover',
  secondary: 'ui_library_popover_secondary',
  promotional: 'ui_library_popover_promotional',
};

const NEXT_CLASS = 'ui_library_popover_next';

type PopoverVariant = 'next';

// ts-prune-ignore-next
export type PopoverProps = AntPopoverProps & {
  type?: keyof typeof typeToClassName;
  variant?: PopoverVariant;
  noPadding?: boolean;
  onClose?: () => void;
};

export const Popover = ({
  noPadding = false,
  placement = 'top',
  type = 'default',
  variant,
  classNames,
  onClose,
  content,
  children,
  ...rest
}: PopoverProps) => {
  const typeClassName = variant === 'next' ? NEXT_CLASS : typeToClassName[type];
  const theme = useTheme();

  return (
    <AntPopover
      classNames={{
        ...classNames,
        root: `${typeClassName} ${noPadding ? 'ui-library-popover-no-padding' : ''} ${
          classNames?.root ?? ''
        }`,
      }}
      placement={placement}
      {...rest}
      content={
        <>
          {type === 'promotional' && (
            <CloseIcon color={theme.token.colorPrimary} onClick={onClose} />
          )}
          {content as React.ReactNode}
        </>
      }
    >
      {children}
    </AntPopover>
  );
};
